import { render } from "./ProfessionalAreasPage.vue?vue&type=template&id=127d4449&scoped=true"
import script from "./ProfessionalAreasPage.vue?vue&type=script&lang=js"
export * from "./ProfessionalAreasPage.vue?vue&type=script&lang=js"

import "./ProfessionalAreasPage.vue?vue&type=style&index=0&id=127d4449&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d4449"]])

export default __exports__